import { formatDateRange, formatSingleDate } from 'utilities/calendarFunctions';
import { Button } from 'pageFramework/uiControls/buttons';
import { CalendarDatePicker } from 'pageFramework/uiControls/inputs';
import { PreviousIcon, NextIcon, EllipseIcon, ExpandIcon } from 'pageFramework/uiControls/icons';
import React from 'react';

export interface ScheduleWeekToolbarProps {
	startDate?: string;
	endDate?: string;
	selectedDate?: string | Date;
	onPreviousWeek?: () => void;
	onNextWeek?: () => void;
	onTodayClick?: () => void;
	handleDateSelect?: (date: string) => void;
}

const ScheduleWeekToolbar: React.FC<ScheduleWeekToolbarProps> = ({
	startDate = '',
	endDate = '',
	selectedDate = '',
	onPreviousWeek,
	onNextWeek,
	onTodayClick,
	handleDateSelect,
}) => {
	const dateHeading = endDate !== '' ? formatDateRange(startDate, endDate) : formatSingleDate(startDate);

	return (
		<section className="schedule-toolbar">
			<div className="container">
				<div></div>
				<div className="view-controls">
					<div className="btn-group">
						<Button color="secondary" variant="outline" onClick={onPreviousWeek} aria-label="Previous week">
							<PreviousIcon />
						</Button>
						<CalendarDatePicker
							onChange={handleDateSelect}
							dateRangeLabel={dateHeading}
							value={selectedDate}
							onTodayClick={onTodayClick}
							defaultDate={startDate}
							view="week"
						/>
						<Button color="secondary" variant="outline" onClick={onNextWeek} aria-label="Next week">
							<NextIcon />
						</Button>
					</div>
				</div>
				<div className="schedule-legend">
					<div className="icon-legend">
						<p>
							<span className="legend-visual">
								<EllipseIcon />
							</span>
							= View All
						</p>
						<p>
							<span className="legend-visual">
								<ExpandIcon />
							</span>
							= Expand
						</p>
					</div>
					<div className="color-legend">
						<p>
							<span className="legend-visual color-swatch color-windows"></span>
							= Windows
						</p>
						<p>
							<span className="legend-visual color-swatch color-entries"></span>
							= Entries
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ScheduleWeekToolbar;